"use client";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStoreAlt } from "@fortawesome/free-solid-svg-icons";

const FlippableCard = (props: any) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleCardFlip = () => {
        setIsFlipped(!isFlipped);
    };

    return (
        <div
            className="relative w-full h-full perspective-1000 text-white flip-container"
            onMouseEnter={handleCardFlip}
            onMouseLeave={handleCardFlip}
        >
            <div className={`flipper ${isFlipped ? "flipped" : ""}`}>
                <div className={`front ${props.invert ? "bg-pink-accent-400" : "bg-deep-purple-accent-700" } p-4 rounded-lg shadow-md flex flex-col items-center justify-center`}>
                    <div className="flex items-center justify-center w-16 h-16 rounded-full border-2">
                        <FontAwesomeIcon
                            icon={faStoreAlt}
                            className="text-white text-2xl"
                        />
                    </div>
                    <h3 className="text-xl text-center font-semibold">
                        {props.frontTitle}
                    </h3>
                </div>

                <div className={`back ${props.invert ? "bg-deep-purple-accent-700" : "bg-pink-accent-400"} text-center p-4 rounded-lg shadow-md flex flex-col justify-center items-center h-full space-y-4`}>
                    <h3 className="text-xl font-semibold">{props.backTitle}</h3>
                    <p>{props.text}</p>
                    <a
                        href={props.href}
                        className="inline-block border border-white px-10 py-3 rounded text-white font-semibold bg-transparent hover:bg-white hover:text-black hover:border-black transition-colors duration-300"
                    >
                        Afla detalii
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FlippableCard;
